<template>
  <el-card class="box-card mb-50 box-search box-staff">
    <span class="tilte-search">{{ $t('staff.index.staff_management') }}</span>
    <el-form ref="formSearch" @submit.prevent="search" :model="dataSearch">
      <template v-if="hasShopIdParam && role !== $userRole.partner.shop">
        <el-row>
          <div class="el-col mr-20" v-if="role !== $userRole.partner.company">
            <el-form-item prop="filters[0][data]">
              <el-input class="company-name w-400" :placeholder="$t('staff.company_name')" v-model="dataSearch['filters[0][data]']"/>
              <span class="text-gray-500"></span>
            </el-form-item>
          </div>
          <div class="el-col">
            <el-form-item prop="filters[1][data]">
              <el-input class="shop-name w-400" :placeholder="$t('staff.shop_name')" v-model="dataSearch['filters[1][data]']"/>
            </el-form-item>
          </div>
        </el-row>
      </template>
      <el-form-item prop="name">
        <el-input :placeholder="$t('staff.staff_name')" v-model="dataSearch['filters[2][data]']" class="w-400"/>
      </el-form-item>
      <div class="mt-20 mb-25">
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{
            $t('btn_search')
          }}
        </el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </div>
    </el-form>
    <table-data
      :data="data"
      :loading="loading"
      :columns="columns"
      :buttons="buttons"
      :hasCreate="true"
      @change-page="handleChangePage"
      @handle-redirect-create="redirectCreate"
      @click-button="handleClickButtonTable"
      @sort="sort"
    >
    </table-data>
  </el-card>
</template>
<script>
import { getListData } from '../../api/staff'

export default {
  props: {
    urls: { type: Object, required: true, default: {} },
    role: { type: Number, required: false }
  },

  data() {
    return {
      formSearch: {
        name: "",
      },
      hasShopIdParam: true,
      data: {},
      loading: true,
      listQuery: {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "company_name",
        "filters[0][data]": "",
        "filters[1][key]": "shop_name",
        "filters[1][data]": "",
        "filters[2][key]": "full_name",
        "filters[2][data]": "",
        "filters[3][key]": "shop_id",
        "filters[3][data]": "",
      },
      columns: [
        {prop: "info", label: "メンバー名", sortable: false, class: ""},
        {prop: "company_name", label: "企業名", sortable: "custom", class: "text-center"},
        {prop: "shop_name", label: "所属名", sortable: "custom", class: ""},
        {prop: "last_login_datetime", label: "最終ログイン日", sortable: "custom", class: "", width: "145"}
      ],
      buttons: [
        {id: "2", label: "詳細", type: "detail", class: "btn btn-detail"}
      ],
      sortProp: {key: 'created_at', dir: 'descending'},
      dataSearch: {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "company_name",
        "filters[0][data]": "",
        "filters[1][key]": "shop_name",
        "filters[1][data]": "",
        "filters[2][key]": "full_name",
        "filters[2][data]": "",
        "filters[3][key]": "shop_id",
        "filters[3][data]": "",
      },
    }
  },

  methods: {
    getListData() {
      const query = {...this.listQuery, ...this.sortProp}
      getListData(query)
      .then(response => response.json())
      .then(response => {
        response.data.records = response.data.records.map(e => {
          return {
            ...e,
            info: this.convertInfo(e.full_name, e.nickname)
          }
        })
        this.data = response.data;
        this.loading = false;
      })
      .catch((error) => {
      })
      .finally(() => {

      });
    },

    handleChangePage(page) {
      this.loading = true;
      this.listQuery.page = page;
      this.getListData();
    },

    search() {
      this.loading = true;
      this.listQuery = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
      this.listQuery.page = 1;
      this.getListData();
    },

    handleClickButtonTable(type, row) {
      switch (type) {
        case 'detail':
          window.location.href = "/staff/" + row.id;
          break;
      }
    },

    sort(sortProps) {
      this.listQuery.page = 1
      this.sortProp = {key: sortProps.prop, dir: sortProps.order};
      this.getListData();
    },

    resetForm() {
      this.dataSearch = {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "company_name",
        "filters[0][data]": "",
        "filters[1][key]": "shop_name",
        "filters[1][data]": "",
        "filters[2][key]": "full_name",
        "filters[2][data]": "",
        "filters[3][key]": "shop_id",
        "filters[3][data]": "",
      };
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get('shop_id') && this.role != this.$userRole.partner.shop) {
        this.dataSearch['filters[3][data]'] = urlParams.get('shop_id');
      }
    },

    convertInfo(fullName, nickname) {
      return `<span v-html="info">${fullName}</span></br>
          <span>${nickname}</span>`;
    },
    redirectCreate() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const params = urlParams.get('shop_id') ? "?shop_id=" + urlParams.get('shop_id') : "";
      window.location.href = this.urls.create + params;
    }
  },

  watch: {
    filter() {
      this.handleFilter()
    }
  },

  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get('shop_id')) {
      this.hasShopIdParam = false;
      this.listQuery['filters[2][key]'] = 'full_name';
      this.listQuery['filters[2][data]'] = '';
      if (this.role != this.$userRole.partner.shop) {
        this.listQuery['filters[3][data]'] = urlParams.get('shop_id');
        this.dataSearch['filters[3][data]'] = urlParams.get('shop_id');
      }
    }
    this.getListData();
  },

  handleFilter() {
    this.getListData();
  },
}
</script>

<style lang="scss" scoped>
  .box-staff {
    .tilte-search {
      margin-bottom: 12px;
    }
  }
  .el-form {
    width: 100%
  }
  .el-card__body {
    &>hr {
      margin: 20px 0;
    }
  }
</style>
